// types
import { ReportColumnDto } from 'src/api';
// constants
import { singleSelectAggregationModels } from '../constants/aggregation-model/single-select';

export function WeekDayColumn(index: number) {
  const column = {
    field: 'weekDay',
    headerName: 'Week day',
    description: 'Week day column',
    type: 'singleSelect',
    index,
    width: 150,
    groupable: true,
    valueOptions: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    availableAggregationFunctions: singleSelectAggregationModels,
    headerAlign: 'center',
    align: 'center',
  } as ReportColumnDto<any, any, any>;
  return column;
}
